import { Dispatch, SetStateAction } from 'react';
import {
  GridToolbarContainer,
  GridToolbarDensitySelector,
  GridToolbarExport,
  GridToolbarFilterButton,
  GridToolbarQuickFilter
} from '@mui/x-data-grid-pro';
import { Icon } from '../../Atoms/Icon';

declare module '@mui/x-data-grid-pro' {
  interface ToolbarPropsOverrides {
    viewName?: string;
  }
}

// Minimal toolbar — density + export only (used by the one-time shared-link page).
export function MinimalReportToolbar({ viewName = 'UPSTACK Views' }: { viewName?: string }) {
  return (
    <GridToolbarContainer sx={{ padding: '0.25rem 0rem 0.25rem 0rem' }}>
      <div className="ml-auto">
        <GridToolbarDensitySelector
          slotProps={{
            button: { color: 'secondary', startIcon: <Icon type="densityIcon" />, sx: { textTransform: 'none' } }
          }}
        />
        <GridToolbarExport
          csvOptions={{ fileName: viewName }}
          slotProps={{
            button: { color: 'secondary', startIcon: <Icon type="exportIcon" />, sx: { textTransform: 'none' } }
          }}
        />
      </div>
    </GridToolbarContainer>
  );
}

// Full toolbar — quick search + filter / density / export, shared by
// the Reports list and the in-portal report viewer. The search uses the default
// GridToolbarQuickFilter so it matches the inventory / cases / projects pages.
export function FullReportToolbar({
  viewName = 'UPSTACK Views',
  setFilterButtonEl
}: {
  viewName?: string;
  setFilterButtonEl?: Dispatch<SetStateAction<HTMLButtonElement | null>>;
}) {
  return (
    <GridToolbarContainer sx={{ padding: '0.25rem 0rem 0.25rem 0rem' }}>
      <GridToolbarQuickFilter data-cy="report-data-search" />
      <div className="ml-auto">
        <GridToolbarFilterButton
          slotProps={{ button: { color: 'secondary', sx: { textTransform: 'none' } } }}
          ref={setFilterButtonEl}
        />
        <GridToolbarDensitySelector
          slotProps={{
            button: { color: 'secondary', startIcon: <Icon type="densityIcon" />, sx: { textTransform: 'none' } }
          }}
        />
        <GridToolbarExport
          csvOptions={{ fileName: viewName }}
          slotProps={{
            button: { color: 'secondary', startIcon: <Icon type="exportIcon" />, sx: { textTransform: 'none' } }
          }}
        />
      </div>
    </GridToolbarContainer>
  );
}
